import { createFileRoute } from "@tanstack/react-router";

import { FriendsPage, friendsSearchSchema } from "@/features/friends";

// «Друзья»: экран целиком из фичи `friends`. Период и показатель таблицы — в search params,
// меняются без новой записи в истории браузера и без прокрутки наверх.
const FriendsRoute = () => {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <FriendsPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true, resetScroll: false })}
    />
  );
};

export const Route = createFileRoute("/friends")({
  validateSearch: friendsSearchSchema,
  component: FriendsRoute,
});
